import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../store/gameStoreMobx';
import BadMovesList from './BadMovesList';
import CommentBox from './CommentBox';
import { useLocale } from '../i18n';

type Tab = 'badMoves' | 'comments';

const tabStyle = (active: boolean): React.CSSProperties => ({
  flex: 1,
  padding: '10px 8px',
  border: 'none',
  borderRight: '1px solid #ddd',
  background: active ? '#e9ecef' : 'transparent',
  cursor: 'pointer',
  fontWeight: active ? 'bold' : 'normal',
  fontSize: '13px',
});

const RightPanelTabs: React.FC<{ onMoveClick: (moveNumber: number) => void; bookmarkRefreshKey: number }> = observer(({ onMoveClick }) => {
  const [activeTab, setActiveTab] = useState<Tab>('badMoves');
  const store = gameStore;
  const { t } = useLocale();

  const currentComment = store.currentMove?.comment || '';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
      <div style={{ display: 'flex', borderBottom: '1px solid #ddd', backgroundColor: '#fff' }}>
        <button onClick={() => setActiveTab('badMoves')} style={tabStyle(activeTab === 'badMoves')}>
          {t('badMoves')}
        </button>
        <button onClick={() => setActiveTab('comments')} style={{ ...tabStyle(activeTab === 'comments'), borderRight: 'none' }}>
          {t('comment')}
        </button>
      </div>
      <div style={{ flex: 1, overflow: 'hidden', backgroundColor: '#f8f9fa' }}>
        {activeTab === 'badMoves' && <BadMovesList onMoveClick={onMoveClick} />}
        {activeTab === 'comments' && <CommentBox comment={currentComment} />}
      </div>
    </div>
  );
});

export default RightPanelTabs;
